import { Box, Flex, Heading } from '@chakra-ui/react'
import React from 'react'
import { DetailLineProps } from './interface'
import DetailLineItem from './DetailLineItem'

const DetailLine: React.FC<DetailLineProps> = ({
  title,
  actionComponent,
  items,
  ...props
}) => {
  return (
    <Box {...props}>
      {(title || actionComponent) && (
        <Flex justifyContent="space-between" mb={2}>
          {title && (
            <Heading fontSize="20px" fontWeight={600}>
              {title}
            </Heading>
          )}
          {actionComponent}
        </Flex>
      )}
      <Flex flexDirection="column" gap={1}>
        {items.map((elm, index) => (
          <DetailLineItem key={index} label={elm.label} value={elm.value} />
        ))}
      </Flex>
    </Box>
  )
}

export default DetailLine
